import React from "react";
import { BsInstagram, BsMessenger } from "react-icons/bs";
import { FaFacebook } from "react-icons/fa";
import { GiWorld } from "react-icons/gi";
import { MdCall, MdMail, MdMap } from "react-icons/md";
import logo from "../../../assets/images/chi/Symbol Black_CHI.png";
const Footer = () => {
  return (
    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1  text-black pt-24 pb-20 gap-10 titlefont px-10">
      <div className="flex flex-col gap-7">
        <div className="flex  items-center gap-4">
          <img src={logo} className="w-14 rounded-full" alt="" />
          <p>Chi</p>
        </div>
        <div className=" text-sm w-60 leading-6 tracking-wide">
          The newest luxury wellness spa experience in Yangon for your inner
          peace and outer beauty.
        </div>
      </div>
      <div className=" flex flex-col gap-7">
        <h1 className=" text-[22px] tracking-wider font-medium"> Contact</h1>
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <p className="">
              <MdMap />
            </p>
            <p className="text-sm">
            No. 10/B, Kan Bawza Street, Golden Valley 1, Bahan Township, Yangon, Myanmar
            </p>
          </div>
          <div className="flex items-center gap-3">
            <p className="">
              <MdCall />
            </p>
            <p className="text-sm">09 770 079787</p>
          </div>

          <div className="flex items-center gap-3">
            <p className="">
              <GiWorld />
            </p>
            <p className="text-sm">
hello@chiwellness.co</p>
          </div>
        </div>
      </div>
      <div className="  text-sm lg:justify-self-end self-end flex gap-5 flex-col-reverse md:flex-col  ">
        <p className="lg:text-end">
          Copyright © {new Date().getFullYear()}- All rights reserved by{" "}
          <span className="font-bold">Chi</span>
        </p>
        <div className="flex lg:justify-end  gap-5">
          <a href="https://www.facebook.com/profile.php?id=100090965144255">
            {" "}
            <FaFacebook size={24} />
          </a>
          <a href="https://m.me/119864817712220">
            <BsMessenger size={24} />
          </a>
          {/* <a href="https://instagram.com/myaniture?igshid=MzRlODBiNWFlZA==">
            {" "}
            <BsInstagram size={24} />
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default Footer;
